export enum SettingsSetBehaviorType {
  /**
   * GLOBAL settings automatically flow through entities in the building. They are applied
   * and merged during building generation.
   */
  GLOBAL = "GLOBAL",
  /**
   * TARGETED settings do not automatically flow through entities in the building. They are
   * only applied if directly loaded into an entity.
   */
  TARGETED = "TARGETED",
}
